import type { FormElement } from 'form-definition';
import { transformElementDefinitionBasedOnConditionality } from '@beamery/lib-convert';
import type { Submission, SubmissionAnswer } from './form.interface';

type Answer = {
  field: string;
  answer?: string | string[] | boolean | null;
};

const processAnswer = (submissionAnswer: SubmissionAnswer) => {
  if (submissionAnswer instanceof File) {
    return submissionAnswer.name;
  }
  return submissionAnswer;
};

const toAnswer = (
  element: FormElement,
  submissionAnswer: SubmissionAnswer,
): Answer => ({
  field: element?.field ?? element?.type,
  answer: processAnswer(submissionAnswer),
});

export const getElementsToShow = (
  formElements: FormElement[],
  formValues: Submission,
): FormElement[] => {
  const elementsToShow: FormElement[] = [];
  const processedAnswers: Answer[] = [];

  formElements.forEach((element) => {
    const resultElement = transformElementDefinitionBasedOnConditionality(
      element,
      processedAnswers,
    );

    if (resultElement.visible) {
      const { visible, ...formElement } = resultElement; // eslint-disable-line @typescript-eslint/no-unused-vars
      elementsToShow.push(formElement as FormElement);
      if (formValues[element.id]) {
        processedAnswers.push(toAnswer(element, formValues[element.id]));
      }
    }
  });

  return elementsToShow;
};
